import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { FileDeleteInterface } from "../../../middleware/interfaces/file/file-delete-interface";

export const FileDelete = {
  Delete: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const fileDeleteData: FileDeleteInterface = state.data;
      const url = "./php/common/deleter-proxy.php";
      await axios
        .post(url, fileDeleteData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
